import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Box from '@mui/material/Box'
import { find } from 'lodash'
import { useAction } from 'utils/actions'
import { useHeaderNavigation } from 'utils/hooks'
import { ReactComponent as IconCelWallet } from 'icons/CelWallet.svg'
import { ReactComponent as IconCelShoppingCart } from 'icons/CelShoppingCart.svg'
import { ReactComponent as IconCelSuitcase } from 'icons/CelSuitcase.svg'
import { ReactComponent as IconCelSupportCenter } from 'icons/CelSupportCenter.svg'

export const TABS = [
  { label: 'My Wallet', to: '/wallet', icon: <IconCelWallet viewBox="0 0 19 20" width="20" height="20" /> },
  { label: 'Shop Travel', to: '/shop-travel/explore', root: '/shop-travel', icon: <IconCelShoppingCart viewBox="0 0 32 30" width="20" height="20" /> },
  { label: 'Trip Planning', to: '/trip-planning', icon: <IconCelSuitcase viewBox="0 0 23 17" width="20" height="20" /> },
  { label: 'Support Center', to: '/faq/user', openChat: true, icon: <IconCelSupportCenter viewBox="0 0 22 20" width="20" height="20" /> },
]

const Navigation = ({

}) => {
  const navigate = useHeaderNavigation()
  const location = useLocation()
  const { pathname } = location
  const { openChat } = useAction()
  // const { hasRole } = useRoles()

  // const checkCurrent = data => data === '/' ? pathname === data : pathname.startsWith(data)

  const value = useMemo(() => {
    return find(TABS, o => pathname === o.to || pathname.startsWith(o.root || o.to))?.to || ''
  }, [pathname])

  return (
    <Box
      display={{
        xx: 'none',
        md: 'contents',
      }}
    >
      <Tabs
        value={value}
        // onChange={(e, value) => navigate(value)}
        onChange={() => {}}
        variant="scrollable"
        scrollButtons="auto"
        sx={theme => ({
          height: '100%',
          '.MuiTabs-flexContainer': {
            height: '100%',
            gridGap: 10,
          },
          '.MuiTabs-indicator': {
            height: 4,
            backgroundColor: theme.palette.text.main_1000,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
          },
          '.Mui-selected': {
            color: theme.palette.text.main_1000,
          },
        })}
        aria-label="navigation bar"
      >
        {TABS.map(o => (
          <Tab 
            key={o.label}
            label={<Box sx={{ position: 'relative', px: 1.5 }}>{o.label}</Box>}
            value={o.to}
            onClick={() => {
              // if (o.openChat) openChat()
              // else navigate(o.to)
              navigate(o.to)
            }}
            sx={theme => ({
              color: 'inherit',
              opacity: 1,
              fontSize: 18,
              lineHeight: '24px',
              fontWeight: 600,
              position: 'relative',
              '&:before': {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                my: 'auto',
                width: '100%',
                height: '60px',
                borderRadius: '10px',
                transition: theme.internalMixins.setTransition(['background-color']),
              },
              '&:hover': {
                '&:before': {
                  bgcolor: value === o.to ? undefined : theme.palette.background.neutralCool_200.main,
                },
              },
            })}
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default Navigation